const CODES = [
  { code: "+34", flag: "🇪🇸", label: "España" },
  { code: "+54", flag: "🇦🇷", label: "Argentina" },
  { code: "+52", flag: "🇲🇽", label: "México" },
  { code: "+57", flag: "🇨🇴", label: "Colombia" },
  { code: "+56", flag: "🇨🇱", label: "Chile" },
  { code: "+51", flag: "🇵🇪", label: "Perú" },
  { code: "+598", flag: "🇺🇾", label: "Uruguay" },
  { code: "+591", flag: "🇧🇴", label: "Bolivia" },
  { code: "+44", flag: "🇬🇧", label: "Reino Unido" },
  { code: "+33", flag: "🇫🇷", label: "Francia" },
  { code: "+49", flag: "🇩🇪", label: "Alemania" },
  { code: "+39", flag: "🇮🇹", label: "Italia" },
  { code: "+1",  flag: "🇺🇸", label: "EEUU/Canadá" },
];

export default function PhoneField({ n, countryCode, onCountryCode, number, onNumber }) {
  return (
    <div className="pt-4">
      <label className="flex justify-between items-baseline mb-2">
        <span className="text-[10px] uppercase tracking-[0.3em] text-white/45">
          Teléfono<span className="text-[#FFB800]"> *</span>
        </span>
        <span className="font-mono text-[10px] text-white/30">{n}</span>
      </label>
      <div className="flex gap-2">
        <select
          value={countryCode}
          onChange={(e) => onCountryCode(e.target.value)}
          className="field-input bg-[#030712] flex-shrink-0"
          style={{ width: "110px" }}
        >
          {CODES.map((c) => (
            <option key={c.code} value={c.code}>
              {c.flag} {c.code}
            </option>
          ))}
        </select>
        <input
          type="tel"
          value={number}
          onChange={(e) => onNumber(e.target.value)}
          placeholder="600 000 000"
          className="field-input"
          style={{ flex: 1, minWidth: 0 }}
        />
      </div>
    </div>
  );
}
